import { render } from "./invoice-cancellation-detail.vue?vue&type=template&id=b4adbc7e"
import script from "./invoice-cancellation-detail.vue?vue&type=script&lang=js"
export * from "./invoice-cancellation-detail.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__